/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CartSubmission } from '../models/cart-submission';
import { cartSubmissionsCreate } from '../fn/cart-submissions/cart-submissions-create';
import { CartSubmissionsCreate$Params } from '../fn/cart-submissions/cart-submissions-create';
import { cartSubmissionsDestroy } from '../fn/cart-submissions/cart-submissions-destroy';
import { CartSubmissionsDestroy$Params } from '../fn/cart-submissions/cart-submissions-destroy';
import { cartSubmissionsList } from '../fn/cart-submissions/cart-submissions-list';
import { CartSubmissionsList$Params } from '../fn/cart-submissions/cart-submissions-list';
import { cartSubmissionsRetrieve } from '../fn/cart-submissions/cart-submissions-retrieve';
import { CartSubmissionsRetrieve$Params } from '../fn/cart-submissions/cart-submissions-retrieve';
import { PaginatedCartSubmissionShortList } from '../models/paginated-cart-submission-short-list';

@Injectable({ providedIn: 'root' })
export class CartSubmissionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `cartSubmissionsList()` */
  static readonly CartSubmissionsListPath = '/msp/api/cart_submissions/';

  /**
   * Allows submitting products for purchase, creates and returns a CartSubmission with new Purchase objects.
   * Update is not supported - instead of updating a CartSubmission, create a new one.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cartSubmissionsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  cartSubmissionsList$Response(params?: CartSubmissionsList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedCartSubmissionShortList>> {
    return cartSubmissionsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows submitting products for purchase, creates and returns a CartSubmission with new Purchase objects.
   * Update is not supported - instead of updating a CartSubmission, create a new one.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cartSubmissionsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cartSubmissionsList(params?: CartSubmissionsList$Params, context?: HttpContext): Observable<PaginatedCartSubmissionShortList> {
    return this.cartSubmissionsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedCartSubmissionShortList>): PaginatedCartSubmissionShortList => r.body)
    );
  }

  /** Path part for operation `cartSubmissionsCreate()` */
  static readonly CartSubmissionsCreatePath = '/msp/api/cart_submissions/';

  /**
   * Allows submitting products for purchase, creates and returns a CartSubmission with new Purchase objects.
   * Update is not supported - instead of updating a CartSubmission, create a new one.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cartSubmissionsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cartSubmissionsCreate$Response(params: CartSubmissionsCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CartSubmission>> {
    return cartSubmissionsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows submitting products for purchase, creates and returns a CartSubmission with new Purchase objects.
   * Update is not supported - instead of updating a CartSubmission, create a new one.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cartSubmissionsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cartSubmissionsCreate(params: CartSubmissionsCreate$Params, context?: HttpContext): Observable<CartSubmission> {
    return this.cartSubmissionsCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CartSubmission>): CartSubmission => r.body)
    );
  }

  /** Path part for operation `cartSubmissionsRetrieve()` */
  static readonly CartSubmissionsRetrievePath = '/msp/api/cart_submissions/{id}/';

  /**
   * Allows submitting products for purchase, creates and returns a CartSubmission with new Purchase objects.
   * Update is not supported - instead of updating a CartSubmission, create a new one.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cartSubmissionsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  cartSubmissionsRetrieve$Response(params: CartSubmissionsRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<CartSubmission>> {
    return cartSubmissionsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows submitting products for purchase, creates and returns a CartSubmission with new Purchase objects.
   * Update is not supported - instead of updating a CartSubmission, create a new one.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cartSubmissionsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cartSubmissionsRetrieve(params: CartSubmissionsRetrieve$Params, context?: HttpContext): Observable<CartSubmission> {
    return this.cartSubmissionsRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<CartSubmission>): CartSubmission => r.body)
    );
  }

  /** Path part for operation `cartSubmissionsDestroy()` */
  static readonly CartSubmissionsDestroyPath = '/msp/api/cart_submissions/{id}/';

  /**
   * Allows submitting products for purchase, creates and returns a CartSubmission with new Purchase objects.
   * Update is not supported - instead of updating a CartSubmission, create a new one.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cartSubmissionsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  cartSubmissionsDestroy$Response(params: CartSubmissionsDestroy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return cartSubmissionsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows submitting products for purchase, creates and returns a CartSubmission with new Purchase objects.
   * Update is not supported - instead of updating a CartSubmission, create a new one.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cartSubmissionsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cartSubmissionsDestroy(params: CartSubmissionsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.cartSubmissionsDestroy$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
